"use strict";

import Home from "./scene/Home";

import EnrichedVideos from "./scene/EnrichedVideos";
import EnrichedVideosInCatalogue from "./scene/EnrichedVideosInCatalogue"
import EnrichedVideosByViolation from "./scene/EnrichedVideosByViolation";
import EnrichedVideosByProgram from "./scene/EnrichedVideosByProgram";
import EnrichedVideo from "./scene/EnrichedVideo";

const contextPath = "/";

const apiPath = "/api";

const routes = [
    {
        label: "Dashboard",
        exact: true,
        path: "/",
        component: Home,
        headerRoute: false,
    },
    {
        label: "Enriched Videos",
        exact: true,
        path: "/enriched-videos",
        component: EnrichedVideos,
        headerRoute: false,
    },
    {
        label: "Enriched Videos",
        exact: true,
        path: "/enriched-videos-in-catalogue",
        component: EnrichedVideosInCatalogue,
        headerRoute: false,
    },
    {
        label: "Enriched Videos By Violation Level",
        exact: true,
        path: "/enriched-videos-by-violation/:violationLevel",
        component: EnrichedVideosByViolation,
        headerRoute: false,
    },
    {
        label: "Enriched Videos By Program",
        exact: true,
        path: "/enriched-videos-by-program/:programId",
        component: EnrichedVideosByProgram,
        headerRoute: false,
    },
    {
        label: "Enriched Video",
        exact: true,
        path: "/enriched-video/:enrichedVideoId",
        component: EnrichedVideo,
        headerRoute: false,
    },
];


function objectToSelectOptions(obj) {
    let options = [];

    Object.keys(obj).forEach(key => options.push({ value: key, label: obj[key] }));

    return options;
}

function arrayToSelectOptions(arr) {
    let options = [];

    arr.forEach(v => options.push({ value: v, label: v }));

    return options;
}

const platformById = {
    "51a0d73e-2304-4bd9-b9a5-9c7d99a301e9": "iOS",
    "b058d380-69ac-4275-abfb-a2da0edfee43": "Android",
    "32faad53-5e7b-4cc0-9f33-000092e85950": "WebMultiDRM",
    "648d4d33-ad1c-4e6e-9175-232219ac5855": "Explora IS20",
    "27d87cac-0702-4c9b-8029-5d44bc61581c": "Explora E36B",
    "3759bd05-6e6a-427f-abc0-336fc138d04b": "Smart Village",
};

function platformFromId(platformId) {
    return platformById[platformId] || '';
}
const platformOptions = objectToSelectOptions(platformById);

const countriesE36B = [
    "AO",
    "BF",
    "BI",
    "BJ",
    "CD",
    "CF",
    "CG",
    "CI",
    "CM",
    "CV",
    "DJ",
    "ER",
    "ET",
    "GA",
    "GH",
    "GM",
    "GN",
    "GQ",
    "GW",
    "KE",
    "KM",
    "LR",
    "MG",
    "ML",
    "MR",
    "MU",
    "NE",
    "NG",
    "RE",
    "RW",
    "SC",
    "SD",
    "SH",
    "SL",
    "SN",
    "SO",
    "SS",
    "ST",
    "TD",
    "TG",
    "TZ",
    "UG"
];

const countriesIS20 = [
    "BW",
    "LS",
    "MW",
    "MZ",
    "NA",
    "SZ",
    "ZA",
    "ZM",
    "ZW"
];

const countriesDiaspora = [
    "US",
    "GB",
    "AE",
    "AU",
    "NZ",
    "DE",
    "IE",
    "IT",
    "PT",
    "FR",
    "NL",
    "CA"
];

const countries = Array.prototype.concat(countriesE36B,countriesIS20,countriesDiaspora).sort();

const countryOptions = (() => {
    let countryOptions = [];

    countryOptions.push({ value: countriesIS20.join(","), label: "IS20" });
    countryOptions.push({ value: countriesE36B.join(","), label: "E36B" });
    countryOptions.push({ value: countriesDiaspora.join(","), label: "Diaspora"});
    countries.forEach(country => countryOptions.push({ value: country, label: country }));

    return countryOptions;
})();

const timeCodeLabelByType = {
    "BLACK_SCREEN" : "Black Screen",
    "BREAK_BUMPER" : "Break Bumper",
    "COMMERCIAL_BREAK" : "Commercial Break",
    "COMMERCIAL_BREAKS" : "Commercial Breaks",
    "CONTENT_SCENE" : "Content Scene",
    "DISCLAIMER" : "Disclaimer",
    "END_CREDITS" : "End Credits",
    "GOOFS" : "Goofs",
    "INTERVIEWS" : "Interviews",
    "OPENING_CREDITS" : "Opening Credits",
    "OPENING_SCENE" : "Opening Scene",
    "OPENING_SEQUENCE" : "Opening Sequence",
    "PRECAP" : "Precap / Coming Up",
    "PRESENTER_LINKS" : "Presenter Links",
    "PRODUCTION_HOUSE" : "Production House",
    "PROGRAMME_LINE_UP" : "Programme Line-up",
    "RECAP" : "Recap / Previously",
    "SHOW_GRAPHICS" : "Show Graphics",
    "SPONSORSHIP" : "Sponsorship",
    "TAGLINES" : "Taglines",
    "VOXPOPS" : "Voxpops",
};

function timeCodeLabelFromType(timeCodeType) {
    return timeCodeLabelByType[timeCodeType] || timeCodeType;
}

export {
    apiPath,
    contextPath,
    routes,
    platformById,
    platformFromId,
    platformOptions,
    countryOptions,
    timeCodeLabelByType,
    timeCodeLabelFromType,
    objectToSelectOptions,
    arrayToSelectOptions,
};
